module.exports = __webpack_public_path__ + "static/media/invoice-download-arrow.619881cd.svg";